module.exports = __webpack_public_path__ + "static/media/marmalade-logo-white.4130e724.svg";